export const Button = {
  // The styles all button have in common
  baseStyle: {
    fontWeight: '600',
  },

  // Two variants: outline and solid
  variants: {
    solid: {
      bg: 'brand.colorPrimary',
      color: 'brand.colorButtonTextPrimary',
      _hover: {
        bg: 'brand.colorSecondary',
        color: 'brand.colorButtonTextSecondary',
      },
    },
    link: { textDecoration: 'underline' },
  },
};
